import { render, staticRenderFns } from "./postsContainer.vue?vue&type=template&id=74aa81c3&scoped=true&"
import script from "./postsContainer.vue?vue&type=script&lang=js&"
export * from "./postsContainer.vue?vue&type=script&lang=js&"
import style0 from "./postsContainer.vue?vue&type=style&index=0&id=74aa81c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa81c3",
  null
  
)

export default component.exports